import { resolveGameApiBase } from '@/services/axios';
import URL from '@/services/urls';
import type { PreviewMazeLevelDto } from '@/types/api/preview';
import axios from 'axios';

interface PreviewEnvelope<T> {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
}

interface PreviewPaginatedData<T> {
  items: T[];
  totalCount: number;
}

interface RawPreviewMazeTemplate {
  id: string;
  levelId: string;
  grid: number[][];
  rows: number;
  cols: number;
  startRow: number;
  startCol: number;
  endRow: number;
  endCol: number;
  shortestPathLength: number;
  level?: {
    name?: string;
  };
}

function toPreviewLevel(raw: RawPreviewMazeTemplate): PreviewMazeLevelDto {
  return {
    levelId: raw.id,
    levelName: raw.level?.name ?? 'Preview',
    rows: raw.rows,
    cols: raw.cols,
    mazeGrid: raw.grid,
    startRow: raw.startRow,
    startCol: raw.startCol,
    endRow: raw.endRow,
    endCol: raw.endCol,
    shortestPathLength: raw.shortestPathLength,
  };
}

async function getPreviewMaze(boardId: string, token: string): Promise<PreviewMazeLevelDto> {
  const response = await axios.get<PreviewEnvelope<PreviewPaginatedData<RawPreviewMazeTemplate>>>(
    `${resolveGameApiBase()}/${URL.ADMIN_MAZE_TEMPLATES}`,
    {
      params: {
        id: boardId,
        limit: 50,
        offset: 0,
      },
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      timeout: 15000,
    },
  );

  const payload = response.data;
  const first = payload.data?.items?.[0];
  if (!response.data.success || !first) {
    throw new Error(payload.message ?? 'Failed to fetch preview maze');
  }

  return toPreviewLevel(first);
}

const previewService = {
  getPreviewMaze,
};

export default previewService;
